export default {
  vueInstance: false,
  ui: {
    loading: {
      times: false,
      doingBooking: false,
      signal: '',
      currentRequest: null, // Track current request to prevent duplicates
      providers: false,
      activitiesForCity: false,
      activitiesForCitySignal: null,
      activityGroupsForCity: false,
      // Armed only by explicit user actions (button click / provider click) to show the slow "next available" toast.
      slowNextAvailableToastArmed: false,
      slowNextAvailableToastSource: null, // 'next-button' | 'provider'
      // Prevent hammering the "bookable groups" endpoint if cache isn't ready yet.
      activityGroupsForCityCooldownUntil: 0,
      activityGroupsForCityCooldownKey: null,
    },
    modalState: 0,
    selectingProvider: false,
    selectingLocation: false,
    timeSlotsToShowMobile: 2,
    didSwipe: false,
    showConfirmationModal: false,
    formErrors: {
      ssn: false,
      ssnAge: false,
      email: false,
      phone: false,
    },
    singleBookingHeadline: window.singleBookingHeadline,
    calendarViewType: 'week',
    showGetNextAvailableTimeButton: false,
    /* 
    Keep track of whether the user is doing a BankID signature on another device or the same device.
    This is used to display messages accordingly.
    */
    signingBankIDOnOtherDevice: false,
    signingBankIDOnSameDevice: false,
  },
  unbookableTreatments: window.profetWPVars.non_bookable_treatments,
  unbookableTreatmentMessage:
    window.profetWPVars.non_bookable_treatment_message,
  firstLoadForActivity: false,
  slickOptions: {
    slidesToShow: 5.5, 
    dots: true,
    infinite: false,
    swipeToSlide: true,
    prevArrow:
      '<a class="slick-arrow arrow-prev"><img src="/wp-content/themes/nordiskakliniken/dist/images/chevron-left.svg"></a>',
    nextArrow:
      '<a class="slick-arrow arrow-next"><img src="/wp-content/themes/nordiskakliniken/dist/images/chevron-right.svg"></a>',
  },
  activityGroups: {
    available: [],
    bookable: [],
    selected: false,
    withActivities: [],
    loaded: false,
    cityBookableGroupIds: null,
    // Group id -> name map, populated by getActivityGroups even in
    // namesOnly mode (treatment pages) — used by tracking (funnelParams)
    // to resolve service_category when the groups UI is unused.
    namesById: null,
  },
  activities: {
    active: [],
    available: [],
    selected: false,
    initialLoad: true,
    loaded: false,
    // Bookable activity ids for selected city (computed server-side); when present we can filter instantly.
    cityBookableIds: null,
    // Cache: key -> boolean (has slots for selected city/location set within a date window)
    cityAvailabilityCache: {},
  },
  // When navigating from the price list with ?activity_id=X, the activity
  // selection must wait until the user has chosen a city (when multiple cities exist).
  // This object stores the matched activity + group so we can apply it after city selection.
  pendingUrlActivity: null, // { activity, activityGroup } | null
  // True when the activity_id came from a URL query parameter (as opposed to being set by PHP on single-treatment pages).
  activityIdFromUrl: false,
  providers: {
    available: [],
    selected: false,
    loaded: false,
    // Provider metadata (used to map selected provider name -> terapeut_id for "next available time")
    metaRows: [],
    metaLoaded: false,
    metaLoading: false,
  },
  locations: {
    available: [],
    selected: false,
  },
  // Add city-related properties
  cities: {
    available: [],
    selected: null,
    loaded: false,
    filteringByActivity: false, // True while we're filtering cities by a URL-provided activity_id.
  },
  dates: {
    current: {
      date: false,
      day: false,
      week: false,
      weekdays: [],
      month: false,
      monthName: false,
      year: false,
      previousWeek: false,
      nextWeek: false,
      weekStartDate: false,
      weekEndDate: false,
      checkBookingsToDate: false,
    },
    active: {
      date: false,
      day: false,
      week: false,
      weekdays: [],
      month: false,
      monthName: false,
      year: false,
      previousWeek: false,
      nextWeek: false,
      weekStartDate: false,
      weekEndDate: false,
      checkBookingsToDate: false,
      monthDates: [],
    },
  },
  availableTimes: [],
  loadedTimes: [],
  selectedSlot: false,
  patient: {
    firstName: '',
    lastName: '',
    ssn: '',
    email: '',
    phone: '',
    gdprConsent: false,
    newsletterSignup: false,
  },
  initiatedCheckout: false,
  booking: {
    message: false,
    timeStart: false,
    timeEnd: false,
    activityName: false,
    completed: false,
    autostartToken: false,
    orderRef: false,
    qrCode: false,
    nbrRuns: 0,
    qrStartToken: '',
    qrStartSecret: '',
    waitingForSign: false,
    showBankIDInstructions: false,
    /* City resolved server-side from the order's location id, returned by the
       orderRef paths. Tracking-only fallback — see resolveBookingCity. */
    cityFromServer: null,
  },
  collectBankIDResponseTimeout: false,
  qrTimeout: false,
  bankIDLocation: 'sameDevice', // The location of the user's bank ID, either "sameDevice" or "otherDevice".
  customTreatmentDurations: {}, // An object with custom treatment durations that are edited through WP admin. These are fetched through a REST call when the Vue app is mounted */
  /* Resolves once getAllAvailableCities has answered. maybeLoadBookingFromOrderRef
     waits on it so the location -> city lookup has data to work with. */
  citiesReady: null,
  orderRefQueryParameterLoaded: false, // Track if we've loaded the orderRef through query parameters. This is used to determine if we should show any potential error messages in a custom popup since the usual
  infoBox: null, // Dynamic gray info box when booking activity */
  priceData: {
    available: null,
    loaded: false,
  },
};
